// Função para ajustar a data com base no fuso horário
const adjustDate = (date) => {
    const adjustedDate = new Date(date);
    // Ajusta a hora subtraindo 3 horas para compensar o fuso horário GMT-3 (horário de Brasília)
    adjustedDate.setHours(adjustedDate.getHours() - 3);
    return adjustedDate;
  };
  
  // Função para formatar a data para o formato dia/mês/ano
  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return adjustDate(date).toLocaleDateString("pt-BR", options);
  };
  
  // Função para formatar a hora para o formato hora:minuto:segundo
  const formatTime = (date) => {
    const options = { hour: "2-digit", minute: "2-digit", second: "2-digit" };
    return adjustDate(date).toLocaleTimeString("pt-BR", options);
  };
  
  // Exporta as funções para que possam ser utilizadas em outros arquivos
  export { adjustDate, formatDate, formatTime };

/**
 * Formata um endereço completo a partir dos campos segregados
 * @param {Object} endereco - Objeto com os campos de endereço
 * @param {string} endereco.cep - CEP
 * @param {string} endereco.logradouro - Logradouro
 * @param {string} endereco.numero - Número
 * @param {string} endereco.complemento - Complemento (opcional)
 * @param {string} endereco.bairro - Bairro
 * @param {string} endereco.cidade - Cidade
 * @param {string} endereco.estado - Estado
 * @returns {string} Endereço formatado
 */
export const formatarEnderecoCompleto = (endereco) => {
  if (!endereco) return "N/A";
  
  const { cep, logradouro, numero, complemento, bairro, cidade, estado } = endereco;
  
  if (!logradouro || !numero || !bairro || !cidade || !estado) {
    return "Endereço incompleto";
  }
  
  let enderecoFormatado = `${logradouro}, ${numero}`;
  
  if (complemento && complemento.trim()) {
    enderecoFormatado += `, ${complemento}`;
  }
  
  enderecoFormatado += `, ${bairro}, ${cidade} - ${estado}`;
  
  if (cep && cep.trim()) {
    enderecoFormatado += `, CEP: ${cep}`;
  }
  
  return enderecoFormatado;
};

/**
 * Verifica se todos os campos obrigatórios de endereço estão preenchidos
 * @param {Object} endereco - Objeto com os campos de endereço
 * @returns {boolean} True se todos os campos obrigatórios estão preenchidos
 */
export const isEnderecoCompleto = (endereco) => {
  if (!endereco) return false;
  
  const { logradouro, numero, bairro, cidade, estado } = endereco;
  
  return !!(logradouro && numero && bairro && cidade && estado);
};
  